// extracted by mini-css-extract-plugin
module.exports = {"inputs":"VacancySalaryRange_inputs__2gBPi"};